export default {
  detail: [
    // 海外ip提示
    'oversea-tip',
    // 头部视频位
    'header-video',
    // 配置通知位
    'config-announce',
    // 头部信息
    'fund-basic-header',
    // 养老Y类
    'fund-pension-a',
    // 关联指数
    'related-index',
    // 相关ETF联接基金
    'etf-relate-fund',
    // 财富号信息
    'cfh-info',
    // 财富号公告
    'cfh-announce',
    // 分红提示
    'bonus-tip',
    // 近一年巨额赎回公告
    'fund-warn-tips',
    // 图表
    'fund-chart-tab',
    // 行情列表
    'fund-market-quotation',
    // 基金档案
    'fund-archives',
    // 基金持仓
    'fund-hold',
    // 分红送配
    'fund-bonus',
    // 特色数据
    'feature-data',
    // 交易规则
    'trade-rule',
    // 公告&资讯
    'notice-and-news',
    // 讨论与问答
    'question-and-discuss',
    // 页面底部
    'page-footer',
  ],
  newFund: [
    // 头部视频位
    'header-video',
    // 头部信息
    'fund-basic-header',
    // 养老Y类
    'fund-pension-a',
    // 配置通知位
    'config-announce',
    // 财富号公告
    'cfh-announce',
    // 新发基金解读
    'new-fund-read',
    // 财富号信息
    'cfh-info',
    // 认购流程
    'new-fund-buy-progress',
    // 基金档案
    'fund-archives',
    // 基金持仓
    'fund-hold',
    // 交易规则
    'trade-rule',
    // 公告&资讯
    'notice-and-news',
    // 讨论与问答
    'question-and-discuss',
    // 页面底部
    'page-footer',
  ],

  highEnd: [
    'HighEndHeader',
    'HighEndPreferredProduct',
    'HighEndInfoTab',
    'HighEndInfoContent',
    'HighEndFixBottomBtn',
  ],
};
